module.exports = __webpack_public_path__ + "img/no_min_data.42535d7c.png";